module.exports = __webpack_public_path__ + "img/giai-phap-goi-von.8bf55d59.png";